import React from 'react'
import Grid from '@material-ui/core/Grid'
import PropTypes from 'prop-types'
import { Alert, AlertTitle } from '@material-ui/lab'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import SydButton from '../../../../../commonDesign/Button'
import SydModalActions from '../../../../../commonDesign/SydModal/SydModalActions'
import { dataCatalog } from '../../../../../../api/coreData'
import CodeBlock from '../../../../../atoms/CodeBlock'

const useStyles = makeStyles(() => ({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 'var(--padding-md)'
  },
  detailsContainer: {
    padding: 'var(--padding-sm)',
    backgroundColor: 'var(--color-surface-050)',
    borderRadius: 'var(--border-radius-md)',
    maxHeight: '60vh',
    overflow: 'auto'
  }
}))

function ViewEventLogDetailsForm ({ eventLogId, onCancel }) {
  const classes = useStyles()
  const { data, isLoading, error } = dataCatalog.useGetCatalogEventDetails(eventLogId)

  if (isLoading) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.loadingContainer}>
          <CircularProgress />
        </Grid>
      </Grid>
    )
  }

  if (error) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity='error'>
            <AlertTitle>Error Loading Details</AlertTitle>
            {error.message || 'Failed to load event log details'}
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <SydModalActions>
            <SydButton
              variant='ghost'
              size='md'
              onClick={onCancel}
            >
              Close
            </SydButton>
          </SydModalActions>
        </Grid>
      </Grid>
    )
  }

  if (!data || !data.details) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity='info'>
            No details available for this event log.
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <SydModalActions>
            <SydButton
              variant='ghost'
              size='md'
              onClick={onCancel}
            >
              Close
            </SydButton>
          </SydModalActions>
        </Grid>
      </Grid>
    )
  }

  const detailJson = data.details?.details || {}

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className={classes.detailsContainer}>
            <CodeBlock code={detailJson} scroll />
          </div>
        </Grid>

        {/* Actions */}
        <Grid item xs={12}>
          <SydModalActions>
            <SydButton
              variant='ghost'
              size='md'
              onClick={onCancel}
            >
              Close
            </SydButton>
          </SydModalActions>
        </Grid>
      </Grid>
    </div>
  )
}

ViewEventLogDetailsForm.propTypes = {
  eventLogId: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default ViewEventLogDetailsForm
